/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable radix */
import React, { useState, useEffect, useRef } from 'react';
import { useOidc } from '@axa-fr/react-oidc';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Backdrop, CircularProgress, Tooltip, Radio, RadioGroup, FormControlLabel, FormControl, Button } from '@mui/material';
import { notification } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
// redux
import { setMyAndSharedFile, getSharedFileOnly, getSharedProjectsList, decryptDataSharedAndMyProject, getSharedProjectAllData, get_all_shared_projects_list, get_checkAPI_shared_Project, set_checkAPI_shared_Project } from '../userData';

import FileShare from '../file_sharing';
import { shareImage, quickViewImage, searchImage, sortAlphaImageAZ, sortAlphaImageZA, DownloadSvgIcon, deleteImage, closeIconBlack, filterCheck, filter_list, filter_alt, folder_open_icon, Icon_Button_Restart } from '../../shared/assets/images';
import Notification from '../../shared/notification-modal';
import { checkFileExists, saveWinflowsFileContent, getWinflowsFileContent, updateProjectInfoDictIsReadtoTrue, deleteWinAndProjectFile, getUserListData } from '../../shared/api/url-helper';
import { defaultModalOptions } from '../../shared/constantVariable';
import HeaderSection from '../header-section';
import QuickViewPopUp from './quick-view';
import './shared-projects.scss';
import { encrypt_data, decrypt_data } from '../../shared/utils';
import { removeItemFromLocalStorage } from '../../shared/removeElements';
import { getEmailUserType, removeLocalStorageValue } from '../../shared/helper';
import { DownloadMainfile } from '../files_details';

let ColorChangeShare = false;
const dataLimit = 20;
let copyofMyFilesLength = 0;
let searchFilterflag = true;
let applyAllStr = false;

const SharedProjectsPopup = () => {
  const { isAuthenticated } = useOidc();
  // redux

  if (isAuthenticated) {
    if (sessionStorage.getItem('expTime') == null) {
      window.location.href = '/sign-in';
    }
  }

  const { t } = useTranslation();
  const translateObject = t;
  const [scrollSheredData, setScrollSheredData] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [visitFirst, setVisitFirst] = useState(false);
  const [selectedCities, setSelectedCities] = useState(null);
  const [flowSheetType, setFlowSheetType] = React.useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [subflowSheetType, setSubflowSheetType] = React.useState({});
  const [tabbingval, setTabbingval] = useState([]);
  const [applyUpdate, setApplyUpdate] = useState(true);
  const navigate = useNavigate();
  const [fetchLoading, setFetchLoading] = useState(false);
  const [visible_fileSharing, setVisible_fileSharing] = useState(false);
  const [text, setText] = useState('');
  const [value, setValue] = React.useState([]);
  const [currentActiveTab, setCurrentActiveTab] = useState(0);
  const [showQuickViewPopup, setShowQuickViewPopup] = useState(false);
  const [showSortingPopup, setShowSortingPopup] = useState(false);
  const [filterSorting, setFilterSorting] = useState('filename');
  const [styleLeft, setStyleLeft] = useState(0);
  const [recentSearchList, setRecentSearchList] = useState([]);
  const [quickViewData, setQuickViewData] = useState(false);
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const [state_loader, setState_loader] = useState(false);
  const [colormatch, setcolormatch] = useState(false);
  const [colormatchQuick, setcolormatchQuick] = useState(false);
  const [colormatchDelete, setcolormatchDelete] = useState(false);
  const [data, setData] = useState([]);
  const [copyData, setCopyData] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const [active, setActive] = useState('');
  const [unreadCount, setUnreadCount] = useState('');
  const inputval = useRef();
  const getUserEmail = sessionStorage.getItem('user_email');
  const getUserType = getUserEmail?.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
  // ant design
  const [api, contextHolder] = notification.useNotification();
  const placement = 'topLeft';  // topLeft topRight
  const [columnWidths, setColumnWidths] = useState([385, 415, 330, 255, 340]); // Default widths
  const [resizing, setResizing] = useState(null);

  const [allSharedListData, setAllSharedListData] = useState([]); // Set All Shared project file list
  const [copySharedListData, setCopySharedListData] = useState([]); // Copy exiting data in Shared-project list
  // const [sharedFileCount, setSharedFileCount] = useState(0);

  const openModelPopUp = (message, title, type) => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title,
      message,
      yesOrNo: false,
      onNo: () => setModalOption(defaultModalOptions),
      type
    });
  };
  function parseDate(dateStr) {
    if (!dateStr) {
      return new Date(); // Return current date or handle as error case
    }

    const [datePart, timePartWithZone] = dateStr.split(' (');
    if (!datePart || !timePartWithZone) {
      return new Date(); // Return current date or handle as error case
    }

    const [day, month, year] = datePart.split('/');
    const [timePart] = timePartWithZone.split(')'); // Safely extract time part
    const [hours, minutes] = timePart.split(':');

    if (!day || !month || !year || !hours || !minutes) {
      return new Date(); // Return current date or handle as error case
    }

    return new Date(year, month - 1, day, parseInt(hours), parseInt(minutes));
  }
  const sortedData = (str) => {
    if (filterSorting === 'filename' || filterSorting === 'projectname' || filterSorting === 'sharedby' || filterSorting === 'createdon' || filterSorting === 'lasteditedon') {
      const val = [...copyData];
      if (filterSorting === 'filename') {
        val.sort((a, b) => {
          if (str !== 'asc')
            return (a.name.toLowerCase() < b.name.toLowerCase()) ? 1 : -1;
          return (a.name.toLowerCase() < b.name.toLowerCase()) ? -1 : 1;
        });
      } else if (filterSorting === 'projectname') {
        val.sort((a, b) => {
          if (str !== 'asc')
            return (a.project_name.toLowerCase() < b.project_name.toLowerCase()) ? 1 : -1;
          return (a.project_name.toLowerCase() < b.project_name.toLowerCase()) ? -1 : 1;
        });
      } else if (filterSorting === 'sharedby') {
        val.sort((a, b) => {
          if (str !== 'asc')
            return (a.sharedby.toLowerCase() < b.sharedby.toLowerCase()) ? 1 : -1;
          return (a.sharedby.toLowerCase() < b.sharedby.toLowerCase()) ? -1 : 1;
        });
      } else if (filterSorting === 'createdon') {
        val.sort((a, b) => {
          const dateA = parseDate(a.created_on);
          const dateB = parseDate(b.created_on);

          if (str !== 'asc') {
            return dateB - dateA; // For descending order
          }
          return dateA - dateB; // For ascending order
        });
      } else if (filterSorting === 'lasteditedon') {
        val.sort((a, b) => {
          const dateA = parseDate(a.last_edited_on);
          const dateB = parseDate(b.last_edited_on);

          if (str !== 'asc') {
            return dateB - dateA; // For descending order
          }
          return dateA - dateB; // For ascending order
        });
      }
      setCopyData([...val]);
    }
    setShowSortingPopup(false);
  };
  const setValueStorage = (inval) => {
    if (inval) {
      let storeVal = localStorage.getItem('sharedProjectStorageVal');
      if (storeVal) {
        storeVal = JSON.parse(storeVal);
        if (storeVal[filterSorting]) {
          let flag = true;
          for (let i = 0; i < storeVal[filterSorting].length; i += 1) {
            if (inval === storeVal[filterSorting][i]) {
              flag = false;
              break;
            }
          }
          if (flag) {
            if (storeVal[filterSorting].length >= 3) {
              storeVal[filterSorting].pop();
            }
            storeVal[filterSorting].unshift(inval);
            localStorage.setItem('sharedProjectStorageVal', JSON.stringify(storeVal));
          }
        } else {
          storeVal[filterSorting] = [inval];
          localStorage.setItem('sharedProjectStorageVal', JSON.stringify(storeVal));
        }
      } else {
        const data = JSON.stringify({
          [filterSorting]: [inval]
        });
        localStorage.setItem('sharedProjectStorageVal', data);
      }
      const data = JSON.parse(localStorage.getItem('sharedProjectStorageVal'));
      setRecentSearchList(data[filterSorting]);
      setSearchVal('');
    }
  };

  const searchFilter = () => {
    const inval = inputval.current.value;
    if (!inval) {
      if (copySharedListData.length !== allSharedListData.length) {
        setScrollSheredData(true);
      }
      setData([...copySharedListData]);
      setCopyData([...copySharedListData]);
      setCopySharedListData([]);
      setShowSortingPopup(false);
      searchFilterflag = true;
      return false;
    }
    if (['filename', 'projectname', 'sharedby'].indexOf(filterSorting) >= 0) {
      let val = [...data];
      if (filterSorting === 'filename') {
        val = val.filter((ele) => {
          if (ele.name)
            return ele.name.toLowerCase().indexOf(inval.toLowerCase()) >= 0;
        });
      } else if (filterSorting === 'projectname') {
        val = val.filter((ele) => {
          if (ele.project_name)
            return ele.project_name.toLowerCase().indexOf(inval.toLowerCase()) >= 0;
        });
      } else if (filterSorting === 'sharedby') {
        val = val.filter((ele) => {
          if (ele.sharedby)
            return ele.sharedby.toLowerCase().indexOf(inval.toLowerCase()) >= 0;
        });
      }
      setCopyData([...val]);
    }
  };

  const searchFilterEnter = (eve) => {
    const inval = inputval.current.value;
    const keyCode = eve.keyCode || eve.which;
    if (inval && keyCode === 13) {
      setValueStorage(searchVal);
      setTimeout(() => {
        setShowSortingPopup(false);
        setSearchVal('');
      }, 0);
    } else {
      if (searchFilterflag) {
        if (data.length !== allSharedListData.length) {
          setScrollSheredData(false);
        }
        searchFilterflag = false;
        setCopySharedListData([...data]);
        setData([...allSharedListData]);
      }
      searchFilter();
    }
  };
  const getFilterFlowSheetType = (data) => {
    const finalCombineData = {};
    data.map((ele) => {
      if (finalCombineData.flow_type) {
        if (ele.flow_type) {
          finalCombineData.flow_type.push(ele.flow_type);
          finalCombineData.flow_type = [...new Set(finalCombineData.flow_type)];
        }
      } else {
        finalCombineData.flow_type = [ele.flow_type];
      }
      if (ele.unittop_sneak_peak_view && Object.keys(ele.unittop_sneak_peak_view).length) {
        Object.keys(ele.unittop_sneak_peak_view).map((sneak) => {
          if (finalCombineData[sneak]) {
            finalCombineData[sneak] = finalCombineData[sneak].concat(ele.unittop_sneak_peak_view[sneak]);
            finalCombineData[sneak] = [...new Set(finalCombineData[sneak])];
          } else {
            finalCombineData[sneak] = ele.unittop_sneak_peak_view[sneak];
          }
        });
      }
      return ele;
    });
    const arr = [];
    Object.keys(finalCombineData).map((ele) => {
      let name = ele;
      if (name === 'flow_type') {
        name = 'Flow Sheet Type';
      } else if (name === 'Chemical_Dosing') {
        name = 'Chemical Dosing';
      }
      arr.push({ name, key: ele, data: finalCombineData[ele] });
    });
    setFlowSheetType(arr);
  };
  const resetQuickFilter = (eve) => {
    if (eve) eve.stopPropagation();
    if (applyUpdate) {
      setSelectedCities(null);
      setTabbingval([]);
    }
    setShowFilter(false);
  };
  const clearAll = (str = '') => {
    if (copySharedListData.length > 0) {
      setApplyUpdate(() => true);
      setSelectedCities(null);
      setTabbingval([]);
      setShowFilter(false);
      if (copySharedListData.length !== allSharedListData.length) {
        setScrollSheredData(true);
      }
      setData([...copySharedListData]);
      setCopyData([...copySharedListData]);
      setCopySharedListData([]);
      searchFilterflag = true;
    } else if (str === 'filterClear' || applyAllStr) {
      setApplyUpdate(() => true);
      setSelectedCities(null);
      setTabbingval([]);
      setShowFilter(false);
      setCopyData([...data]);
    }
    applyAllStr = false;
  };
  const applyFilter = () => {
    applyAllStr = true;
    const val = [...data];
    const type = flowSheetType.filter((ele) => ele.name === selectedCities);
    if (type.length) {
      if (type[0].key === 'flow_type') {
        const filterVal = val.filter(ele => tabbingval.indexOf(ele.flow_type) >= 0);
        setCopyData([...filterVal]);
      } else {
        const filterVal = [];
        val.forEach(ele => {
          if (ele.unittop_sneak_peak_view && Object.keys(ele.unittop_sneak_peak_view) && Object.keys(ele.unittop_sneak_peak_view).indexOf(type[0].key) >= 0) {
            tabbingval.forEach((d) => {
              if (ele.unittop_sneak_peak_view[type[0].key].indexOf(d) >= 0) {
                const filterdata = filterVal.filter((val) => {
                  return (val.name === ele.name && val.project_name === ele.project_name && val.filename === ele.filename);
                });
                if (filterdata.length === 0)
                  filterVal.push(ele);
              }
            });
          }
        });
        setCopyData([...filterVal]);
      }
    }
    setApplyUpdate(false);
    setShowFilter(false);
  };
  const getFlowSheetFilterWrapperHeight = () => {
    setTimeout(() => {
      if (document.querySelector('.navbar-menu') && document.querySelector('.wrapper-sort') && document.querySelector('.flow-sheet-filter-wrapper')) {
        const h1 = document.querySelector('.navbar-menu').offsetHeight;
        const t1 = document.querySelector('.wrapper-sort').offsetTop;
        const t2 = document.querySelector('.flow-sheet-filter-wrapper').offsetTop;
        if (t2 > 0) {
          const t3 = document.querySelector('.flow-sheet-filter-wrapper').offsetHeight;
          const total = h1 + t1 + t2 + t3;
          if (window.innerHeight < total) {
            document.querySelector('.flow-sheet-filter-wrapper').style.setProperty('bottom', '0', '');
          } else {
            document.querySelector('.flow-sheet-filter-wrapper').style.setProperty('bottom', '', '');
          }
        }
      }
    }, 100);
  };
  // const unreadCountSharedData = (resObj) => {
  //   const unreadData = Object.values(resObj).filter((unreadCount) => {
  //     return unreadCount.isRead === false;
  //   });
  //   setUnreadCount(unreadData);
  // };
  // const setOnlyMyFile = (resFiles) => {
  //   const resultData = resFiles.map(item => {
  //     item.name = item.filename.split('.json')[0];
  //     return item;
  //   });
  //   setFetchLoading(false);
  //   setData((prev) => [...prev, ...resultData]);
  //   setCopyData((prev) => [...prev, ...resultData]);
  //   setPageNumber(pageNumber + 1);
  //   getFilterFlowSheetType([...data, ...resultData]);
  // };
  const setOnlySharedFile = (resFiles) => {
    // const resultData = resFiles.map((item, ind) => {
    //   if (resFilesName[ind].includes('-sharedFile.json')) {
    //     item.name = `${item.filename}`.includes('-sharedFile.json') ? `${item.filename}` : `${item.filename}-sharedFile.json`;
    //   } else {
    //     item.name = `${item.filename}`;
    //   }
    //   return item;
    // });
    // setFetchLoading(false);
    // const myfile = [];
    // let count = 0;
    // resultData.map((data) => {
    //   if (data.name.indexOf('-sharedFile.json') >= 0) {
    //     data.name = data.name.split('-sharedFile.json')[0];
    //     data.name = data.name.split('.json')[0]; // inCase .json occur two times
    //     if (count < resFilesName.length) data.unread = true;
    //     else data.unread = false;
    //     myfile.push(data);
    //     count += 1;
    //   }
    // });
    const resultData = resFiles.map(item => {
      item.name = item.filename.split('-sharedFile.json')[0];
      item.name = item.name.split('.json')[0]; // inCase .json occur two times
      return item;
    });
    setFetchLoading(false);
    setData((prev) => [...prev, ...resultData]);
    setCopyData((prev) => [...prev, ...resultData]);
    setPageNumber(pageNumber + 1);
    getFilterFlowSheetType([...data, ...resultData]);
  };
  const getSharedProjectListData = async () => {
    // setState_loader(true);
    const dataSharedProject = await getSharedProjectsList(getUserEmail, getUserType, pageNumber, dataLimit, 'shared_projects');
    const response = dataSharedProject.data;
    // const sharedFilesLength = dataSharedProject.data.filecount;
    copyofMyFilesLength = dataSharedProject.data.filecount;
    // setSharedFileCount(sharedFilesLength);
    const resFiles = decryptDataSharedAndMyProject(response);
    // const resObj = {}; // eslint-disable-next-line
    // Object.keys(response.data).forEach((item, ind) => resObj[item] = resFiles[ind]);
    setOnlySharedFile(resFiles);
    // setState_loader(false);
    // let remainingFiles = (sharedFilesLength - [...data, ...resFiles].length);
    if (copyofMyFilesLength === [...data, ...resFiles].length) {
      setScrollSheredData(false);
      setTimeout(() => {
        if (document.getElementById('infinite-loader')) document.getElementById('infinite-loader').classList.add('hide');
      }, 100);
    }
    setVisitFirst(true);
  };

  // Utility function to check if an element has a scrollbar
  const hasScrollbar = element =>
    element && (element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth);

  useEffect(() => {
    const scrollableDiv = document.getElementById('sidebarScrollableDiv');  // By Abhishek on 23-June-25 : to fixed issue : when fileCount was <= 10, then we are seeing repeated files
    if (scrollableDiv && !hasScrollbar(scrollableDiv) && pageNumber !== 1 && copyofMyFilesLength !== copyData.length) {
      getSharedProjectListData();
    }
  }, [pageNumber]);
  const getUnradCountData = async () => {
    const data = await getSharedProjectsList(getUserEmail, getUserType, 1, 0, 'shared_file_count');
    setUnreadCount(data);
  };
  useEffect(async () => {
    getFlowSheetFilterWrapperHeight();
    // for unread file only Start
    if (localStorage.getItem('shared_file_count')) {
      const arr = JSON.parse(localStorage.getItem('shared_file_count'));
      setUnreadCount(arr);
    } else {
      getUnradCountData();
    }
    removeItemFromLocalStorage();
    removeLocalStorageValue();
    getUserListData();
    // localStorage.removeItem('sharedProjectStorageVal');
    getSharedProjectListData();
    // for unread file only End
    /* if (isObjectEmpty(getSharedFileOnly())) {
      const myFileObj = getSharedFileOnly();
      const keys = Object.keys(myFileObj);
      const values = Object.values(myFileObj);
      setOnlySharedFile(keys, values);
      // unreadCountSharedData(myFileObj);
    } else {
      setFetchLoading(true);
      const data = await getSharedProjectsList(getUserEmail, getUserType);
      const response = data.data;
      const resFiles = Object.values(response.data).map(item => {
        if (item[0] !== '{' && item[0] !== undefined) {
          const res_data = item.split('"')[1];
          if (res_data) {
            item = decrypt_data(res_data);
          }
          else {
            item = decrypt_data(item);
          }
        } else {
          const final_data = item; // JSON.parse(response.data);
          item = JSON.parse(final_data);
        }
        return item;
      });
      const resObj = {}; // eslint-disable-next-line
      Object.keys(response.data).forEach((item, ind) => resObj[item] = resFiles[ind]);
      setSharedFileOnly(resObj);
      const resFilesName = Object.keys(response.data);
      // call the function :: send keys and enc. values
      setOnlySharedFile(resFilesName, resFiles);
    } */
  }, []);

  const closeQuickViewPopup = () => {
    setShowQuickViewPopup(false);
    setcolormatchQuick(false);
  };

  const openQuickView = (ele) => {
    setcolormatchQuick(true);
    setQuickViewData(ele);
    setShowQuickViewPopup(true);
  };

  const filterPopup = (ele, ind, event) => {
    event.stopPropagation();
    if (['filename', 'projectname', 'sharedby', 'createdon', 'lasteditedon'].indexOf(ele.str) >= 0) {
      setFilterSorting(ele.str);
      setShowSortingPopup(true);
      const finalLeft = (event.target.closest('li').offsetLeft + 10);
      setStyleLeft(finalLeft);
      const data = JSON.parse(localStorage.getItem('sharedProjectStorageVal'));
      setRecentSearchList([]);
      if (data && data[ele.str]) { setRecentSearchList(data[ele.str]); }
    } else if (ele === 'filterstr') {
      setShowFilter(true);
      getFlowSheetFilterWrapperHeight();
    }
  };

  const shareFileData = (data) => {
    ColorChangeShare = true;
    setcolormatch(true);
    setText(data.name);
    setValue(data);
    setVisible_fileSharing(true);
  };

  const searchByrecent = (ele) => {
    setSearchVal(ele);
    searchFilterflag = true;
    inputval.current.value = ele;
    if (searchFilterflag) {
      searchFilterflag = false;
      setCopySharedListData([...data]);
      setData([...allSharedListData]);
    }
    setTimeout(() => {
      setShowSortingPopup(false);
      setSearchVal('');
    }, 100);
  };
  useEffect(() => {
    if (copySharedListData.length > 0) {
      searchFilter();
    }
  }, [copySharedListData]);

  // delete win and project file start
  const deleteWinAndProjectFileFromS3 = (ele) => {
    setModalOption(defaultModalOptions);
    setcolormatchDelete(false);

    const deletedFileName = `${ele.name}-sharedFile.json`;

    const data = {};
    data.files = { '0': `${getUserEmail}_${deletedFileName}` };

    setState_loader(true);

    // axios({
    //   method: 'post',
    //   url: `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/delete_s3_files?param1=${getUserEmail}&param2=${getUserType}`,
    //   headers: {},
    //   data : JSON.stringify(data.files)
    // })
    // calling the api and sending getUserEmail as param1, getUserType as param2 and JSON.stringify(data.files) as data
    deleteWinAndProjectFile(getUserEmail, getUserType, JSON.stringify(data.files))
      .then(() => {
        setState_loader(false);
        // removing the deleted file form copyData array
        const newCopyData = copyData.filter(item => item.name !== ele.name);
        // setting the filtered data into copyData array
        setCopyData([...newCopyData]);
        const getVal = getSharedFileOnly();
        delete getVal[deletedFileName];
        setMyAndSharedFile(getVal);
        // showing the successfull notification
        api.success({
          message: translateObject('File deleted succesfully'),
          placement,
          closable: false,
          icon: null
        });
      })
      .catch(() => { // if any error occur while deleting file
        setState_loader(false);
        api.error({
          message: translateObject('Error while deleting file'),
          placement,
          closable: false,
          icon: null
        });
      });
  };
  // delete win and project file ends

  const handleDeleteFile = (ele) => {
    setcolormatchDelete(true);
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title: 'Warning',
      message: translateObject('Are you sure you want to delete it?'),
      yesOrNo: true,
      onNo: () => {
        setModalOption(defaultModalOptions);
        setcolormatchDelete(false);
      },
      onYes: () => deleteWinAndProjectFileFromS3(ele),
    });
  };
  const handleFormSubmit = async (type, email) => {
    setState_loader(true);
    if (value && value.name) {
      const name = `${value.name.split('.json')[0]}-sharedFile.json`;

      getWinflowsFileContent(getUserEmail, name, getUserType)

        // await axios
        //   // .post(`https://4wyldoizc5.execute-api.us-east-1.amazonaws.com/dev/winflows_fileopen?param1=${getUserEmail}_${name}`)
        //   .get(`https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_get_winfile_content?param1=${getUserEmail}_${name}&param2=${getUserEmail}&param3=${getUserType}`)
        .then((response) => {
          if (email) {
            if (response.data[0] !== '{' && response.data[0] !== undefined) {
              const res_data = response.data.split('"')[1];
              if (res_data) {
                response.data = decrypt_data(res_data);
              } else {
                response.data = decrypt_data(response.data);
              }
            } else {
              const final_data = response.data; // JSON.parse(response.data);
              response.data = final_data;
            }

            const FlowData = response.data;

            const params = { file_name: `${getUserEmail}_${text}-sharedFile.json` };
            checkFileExists(params).then((res) => {
              const { exist } = res.data;
              let sharedFileName = '';
              const originalText = `${text}-sharedFile`;
              if (exist) {
                const randomNum = Math.random().toString(36).slice(2, 5);
                if (originalText.indexOf('-sharedFile') < 0) {
                  sharedFileName = `${originalText}_${randomNum}-sharedFile.json`;
                } else {
                  const finalName = originalText.split('-sharedFile')[0];
                  sharedFileName = `${finalName}_${randomNum}-sharedFile.json`;
                }
              } else if (originalText.indexOf('-sharedFile') < 0) {
                sharedFileName = `${originalText}-sharedFile.json`;
              } else {
                const finalName = originalText.split('-sharedFile')[0];
                sharedFileName = `${finalName}-sharedFile.json`;
              }
              // Update shared by whom
              FlowData.projectInfo_dict.sharedby = sessionStorage.getItem('user_name');
              FlowData.projectInfo_dict.isRead = false;

              const cipher_new = encrypt_data(FlowData);
              // const receiverUserType = email[0].split('@')[1] === 'veolia.com' ? 'internal' : 'external';
              Promise.all(email.map(userEmail => {
                saveWinflowsFileContent(sharedFileName, userEmail, getEmailUserType(userEmail), cipher_new);
              }))
                // saveWinflowsFileContent(sharedFileName, email[0], receiverUserType, cipher_new)
                // axios({
                //   method: 'post',
                //   // url: `https://fzdb4yphq8.execute-api.us-east-1.amazonaws.com/dev/filestore?param1=${sharedFileName}&param2=${getUserEmail}`,
                //   url: `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_file_save?param1=${sharedFileName}&param2=${email}&param3=${getUserType}`,
                //   headers: {},
                //   data: FlowData
                // })
                .then(() => {
                  setState_loader(false);
                  openModelPopUp(translateObject('File shared successfully!.'), 'Success!', 'success');
                });
            });
          }
        }).catch(() => {
          setState_loader(false);
          openModelPopUp('Failed to save feed input', 'Error', 'error');
        });
    }
  };
  const activeTabSet = (ele) => {
    const selectedArr = tabbingval;
    if (selectedArr.indexOf(ele) < 0) {
      selectedArr.push(ele);
    } else {
      selectedArr.splice(selectedArr.indexOf(ele), 1);
    }
    setTabbingval(() => {
      return [...selectedArr];
    });
  };
  const handleChange = (event) => {
    setSelectedCities(event.target.value);
    const data = flowSheetType.filter((ele) => {
      return ele.name === event.target.value;
    });
    if (data.length) {
      setSubflowSheetType(() => { return { ...data[0] }; });
      setTabbingval([]);
    }
    getFlowSheetFilterWrapperHeight();
  };
  const getReadData = (ind) => {
    setActive(copyData[ind].name);
  };

  const setunReadandOpenFile = (fileName) => {
    // Hit an API which will update the ProjectInfo_dict of selected file
    // only unRead parmater need to update => change it ot 'true'

    // after sucessfully done above step -> nevigate to 'canvas and open the file'
    const selectedFilePinfodetails = copyData.find(item => item.name === fileName);

    if (selectedFilePinfodetails.isRead === false) {
      selectedFilePinfodetails.isRead = true;

      const ciferData = encrypt_data(selectedFilePinfodetails);

      const fName = selectedFilePinfodetails.filename;

      updateProjectInfoDictIsReadtoTrue(fName, getUserEmail, getUserType, ciferData)

        // axios({
        //   method: 'post',
        //   url: `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_project_file_save?param1=${fName}&param2=${getUserEmail}&param3=${getUserType}`,
        //   headers: {},
        //   data: ciferData
        // })
        .then(() => { })
        .catch((e) => {
          console.error('Shared Project info updation Failed: ', e);
        });
      localStorage.removeItem('shared_file_count');
    }

    navigate(`/main?${fileName}-sharedFile.json`);
  };
  const handleMouseDown = (index) => (e) => {
    setResizing(index);
    const startX = e.clientX;
    const startWidth = columnWidths[index];

    const handleMouseMove = (e) => {
      const currentWidth = startWidth + e.clientX - startX;
      const newWidths = [...columnWidths];
      newWidths[index] = currentWidth;
      setColumnWidths(newWidths);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
      setResizing(null);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };
  useEffect(async () => {
    const flag_my_project_api = get_checkAPI_shared_Project();
    if (flag_my_project_api) {
      set_checkAPI_shared_Project();
      const resultData = await getSharedProjectAllData(getUserEmail, getUserType);
      setAllSharedListData(resultData);
    } else {
      const data = get_all_shared_projects_list();
      if (data && Object.prototype.toString.call(data) === '[object Array]') {
        setAllSharedListData(data);
      } else {
        const flagMyList = setInterval(() => {
          const mydata = get_all_shared_projects_list();
          if (mydata) {
            clearInterval(flagMyList);
            setAllSharedListData(mydata);
          }
        }, 1000);
      }
    }
  }, []);
  return (
    <div onClick={() => { setValueStorage(searchVal); resetQuickFilter(''); setShowSortingPopup(false); }}>
      {contextHolder}
      <div style={{ backgroundColor: '#FFF', height: '0px' }} />
      <div style={{ backgroundColor: 'white' }}>
        <HeaderSection />
        <Notification options={modalOption} handleClose={() => setModalOption(defaultModalOptions)} />
        <Backdrop open={fetchLoading || state_loader} style={{ 'zIndex': 1, backgroundColor: 'transparent' }}>
          <CircularProgress color="inherit" style={{ color: '#4b93f4' }} />
        </Backdrop>
        <div style={{ opacity: fetchLoading ? 0 : 1 }} className='shared-projects-box'>
          <div className='shared-project-header' style={{ marginTop: '18px' }}>
            {/* <span style={{ marginLeft: '48px', marginRight: '8px' }} className='L_heading forground-text-primary'>{translateObject('Received Projects')} ({copyData.length} of {sharedFileCount})</span> */}
            <span style={{ marginLeft: '48px', marginRight: '8px' }} className='L_heading forground-text-primary'>{translateObject('Received Projects')}
              {(() => {
                if (copyData.length > 0) {
                  return ` (${(copyData.length)})`;
                }
                return '';
              })()}
            </span>
            {(unreadCount.length > 0) && (
              <span className='unread-data'>
                <span className='count'>{unreadCount.length}</span>
                <span className='text'>{translateObject('Unread')}</span>
              </span>
            )}
          </div>
          <div className='landing-wrapper-my-shared'>
            <div className='shared-project-list' style={{ display: 'none' }}>
              <ul>
                <li onClick={() => { setCurrentActiveTab(0); }} className={`${currentActiveTab === 0 ? 'active' : ''}`}>{translateObject('All')} ({data.length})</li>
                <li onClick={() => { setCurrentActiveTab(1); }} className={`${currentActiveTab === 1 ? 'active' : ''}`}>{translateObject('Current')} (-)</li>
                <li onClick={() => { setCurrentActiveTab(2); }} className={`${currentActiveTab === 2 ? 'active' : ''}`}>{translateObject('Archive')} (-)</li>
              </ul>
            </div>
            <div className="wrapper-sort">
              <div className="wrapper-sort_header">
                <ul className="wrapper-sort_header-sticky" style={{ background: 'none', marginBottom: '4px' }} >
                  {[{ 'str': 'filename', 'text': translateObject('File Name') }, { 'str': 'projectname', 'text': translateObject('Project Name') }, { 'str': 'sharedby', 'text': translateObject('Shared by') }, { 'str': 'createdon', 'text': translateObject('Created On') }, { 'str': 'lasteditedon', 'text': translateObject('Last Edited On') }].map((ele, ind) => {
                    return (
                      <li key={ind} className={`resizable ${ele.text.toLowerCase().split(' ').join('-')}`} style={{ width: `${columnWidths[ind]}px` }}>
                        {ele && ele.text ? ele.text : ''}
                        {(['createdon', 'lasteditedon'].indexOf(ele.str) < 0) &&
                          <span className="icon_filter" onClick={(event) => filterPopup(ele, ind, event)}>
                            <img src={filter_list} />
                          </span>
                        }
                        {(['filename', 'projectname', 'sharedby'].indexOf(ele.str) < 0) &&
                          <span className="icon_filter" onClick={(event) => filterPopup(ele, ind, event)}>
                            <img src={filter_list} />
                          </span>
                        }
                        {['filename', 'projectname', 'sharedby', 'createdon'].includes(ele.str) && (
                          <div className="resize-handle" style={{
                            borderLeft: resizing === ind ? '3px solid #0679CC' : '3px solid #002D62'
                          }} onMouseDown={handleMouseDown(ind)} />
                        )}
                      </li>
                    );
                  })}
                  <li className='' style={{ width: '34%', justifyContent: 'end', marginRight: '0px', marginBottom: '12px' }}>
                    <Tooltip title='Filter' placement="bottom" arrow>
                      <div className='reset-filter' onClick={(event) => { filterPopup('filterstr', 0, event); }} style={{ marginRight: '8px' }}>
                        <img src={filter_alt} />
                        {!applyUpdate && (<div className='filter-count'>{tabbingval.length}</div>)}
                      </div>
                    </Tooltip>
                    <Tooltip title='Reset' placement="bottom" arrow>
                      <div className='reset-filter' onClick={() => clearAll()}>
                        <img src={Icon_Button_Restart} alt='reset' />
                      </div>
                    </Tooltip>
                  </li>
                </ul>
                {showSortingPopup && (
                  <div onClick={(event) => { event.stopPropagation(); }} className='quick-view-filter' style={{ 'left': `${styleLeft}px`, height: 'auto' }}>
                    <div className="input-containers" style={{ marginBottom: '5px' }}>
                      <input ref={inputval} placeholder={translateObject('Enter name to Search')} type="text" name="search" value={searchVal} onKeyUp={(e) => { searchFilterEnter(e); }} onChange={(e) => setSearchVal(e.target.value)} />
                      <img onClick={() => { setValueStorage(searchVal); setShowSortingPopup(false); }} src={searchImage} alt='search-icon' />
                    </div>
                    {(recentSearchList.length > 0) && (
                      <div className='quick-view-recent-search'>
                        <div className='recent-placeholder S_Regular'><span>{translateObject('Recent Search')} </span> <span className='hl' /></div>
                        <ul className='quick-view-recent-search-list'>
                          {recentSearchList && recentSearchList.map((ele, ind) => {
                            return (<li onClick={() => { searchByrecent(ele); }} className='S_Regular' key={ind}><span>{ele}</span></li>);
                          })}
                        </ul>
                      </div>
                    )}
                    <div className='quick-sort'>
                      <div className='recent-placeholder S_Regular'><span>{translateObject('Sorting')}</span> <span className='hl' /></div>
                      <ul>
                        <li onClick={() => sortedData('asc')}>
                          <div className='asc'>
                            <img src={sortAlphaImageAZ} />
                            <span className='S_Regular'>Sort A to Z</span>
                          </div>
                        </li>
                        <li onClick={() => sortedData('desc')}>
                          <div className='asc'>
                            <img src={sortAlphaImageZA} />
                            <span className='S_Regular'>Sort Z to A</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
              {showFilter && (
                <div className='flow-sheet-filter-wrapper'>
                  <div className='flow-sheet-filter'>
                    <div className='flow-sheet-filter-header'>
                      <div className='flow-filter-head'>
                        <span>{translateObject('Filters')}</span>
                        <Tooltip title="Close" onClick={(event) => { resetQuickFilter(event); }}>
                          <img src={closeIconBlack} alt="close" style={{ display: 'block' }} className="pointer" />
                        </Tooltip>
                      </div>
                      <div className='flow-filter-subhead'>{translateObject('Choose any one parameter')}</div>
                    </div>
                    <div onClick={(event) => { event.stopPropagation(); }} className='flow-quick-view-filter'>
                      <div className="flow-input-containers">
                        <FormControl>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                            value={selectedCities}
                            onChange={(event) => handleChange(event)}
                          >
                            {flowSheetType.length && flowSheetType.map((ele, ind) => {
                              return <FormControlLabel className='quick-view-filter-content' key={ind} value={ele.name} control={<Radio size="small" sx={{
                                color: '#0679CC',
                                '&.Mui-checked': {
                                  color: '#0679CC',
                                },
                              }} />} label={ele.name} />;
                            })}
                          </RadioGroup>
                        </FormControl>
                        {selectedCities && (
                          <div className='filter-content'>
                            {Object.keys(subflowSheetType).length > 0 && subflowSheetType.data.map((ele, ind) => {
                              if (ele) {
                                return (
                                  <div className={`S_Regular ${tabbingval.indexOf(ele) >= 0 ? 'active' : ''}`} onClick={() => activeTabSet(ele)} key={ind} style={ind === subflowSheetType.data.length - 1 ? { marginBottom: '5px' } : {}}>
                                    <span><img src={filterCheck} alt='' /></span>
                                    <span key={ind}>{ele === 'E-Cell-3X' ? 'MK-5' : ele}</span>
                                  </div>
                                );
                              }
                              return '';
                            })}
                          </div>
                        )}
                      </div>
                      <div className='sub-head-filter'>
                        <Button className='clear-all M_Bold' onClick={() => { clearAll('filterClear'); }}>Clear All</Button>
                        <Button className='ok-btn' disabled={tabbingval.length === 0} onClick={() => { applyFilter(); }}>{translateObject('Apply')}</Button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="wrapper-sort_list" id="sidebarScrollableDiv">
                <InfiniteScroll scrollableTarget="sidebarScrollableDiv" dataLength={copyData.length} next={() => getSharedProjectListData()} hasMore={scrollSheredData} loader={<span id='infinite-loader' className='infinite-loader' />}>
                  {copyData.map((ele, ind) => {
                    return (
                      <ul key={ind} className={`wrapper-sort_inner S_Regular ${ele.isRead ? '' : 'unread'} ${active === ele.name ? 'active' : ''}`} style={{ marginBottom: '4px' }} onClick={() => getReadData(ind)}>
                        <li title={ele.name} style={{ width: `${columnWidths[0]}px`, borderRight: '2px solid white' }}>
                          <Tooltip title={ele.name} placement="right" arrow>
                            <span className="icon_button fnameCol" onClick={() => setunReadandOpenFile(ele.name)}>
                              {ele.name}
                            </span>
                          </Tooltip>
                        </li>
                        <li className='Forground-Text-Label' style={{ width: `${columnWidths[1]}px`, borderRight: '2px solid white' }}><span className='text_label_formate'>{ele.project_name ? ele.project_name : '--'}</span></li>
                        <li className='Forground-Text-Label' style={{ width: `${columnWidths[2]}px`, borderRight: '2px solid white' }}><span className='text_label_formate'>{ele.sharedby ? ele.sharedby : '--'}</span></li>
                        <li className='Forground-Text-Label' style={{ width: `${columnWidths[3]}px`, borderRight: '2px solid white' }}><span className='text_label_formate'>{ele.created_on ? ele.created_on : '--'}</span></li>
                        <li className='Forground-Text-Label' style={{ width: `${columnWidths[4]}px` }}><span className='text_label_formate'>{ele.last_edited_on ? ele.last_edited_on : '--'}</span></li>
                        <li>
                          <div className="sharing_button">
                            <Tooltip title="Open File" placement="bottom" arrow>
                              <span className="icon_button" onClick={() => setunReadandOpenFile(ele.name)}>
                                <img src={folder_open_icon} />
                              </span>
                            </Tooltip>
                            <Tooltip title="Share File" placement="bottom" arrow>
                              <span className={`icon_button ${colormatch ? 'changeBackgroudcolor' : ''}`} onClick={() => { shareFileData(ele); }}>
                                <img src={shareImage} />
                              </span>
                            </Tooltip>
                            <Tooltip title="Quick View" placement="bottom" arrow>
                              <span onClick={() => { openQuickView(ele, ind); }} className={`icon_button ${colormatchQuick ? 'changeBackgroudcolorQuick' : ''}`}>
                                <img src={quickViewImage} />
                              </span>
                            </Tooltip>
                            <Tooltip title="Download File" placement="bottom" arrow>
                              <span className="icon_button" onClick={() => { DownloadMainfile(ele); }}>
                                <img src={DownloadSvgIcon} />
                              </span>
                            </Tooltip>
                            <Tooltip title="Delete File" placement="bottom" arrow>
                              <span onClick={() => { handleDeleteFile(ele, ind); }} className={`icon_button ${colormatchDelete ? 'changeBackgroudcolorDelete' : ''}`}>
                                <img src={deleteImage} />
                              </span>
                            </Tooltip>
                          </div>
                        </li>
                      </ul>
                    );
                  })}
                </InfiniteScroll>
                {(copyData.length === 0 && visitFirst) && (
                  <div className='no-data-found'>{translateObject('No Data Found...')}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {showQuickViewPopup && (
        <div className="file-share-draggable">
          <QuickViewPopUp
            visibleQuickView={showQuickViewPopup}
            closeQuickViewPopup={closeQuickViewPopup}
            quickViewData={quickViewData}
            translateObject={translateObject}
          />
        </div>
      )}
      {visible_fileSharing && (
        <div className="file-share-draggable">
          <FileShare
            visible_fileSharing={visible_fileSharing}
            setVisible_fileSharing={setVisible_fileSharing}
            setcolormatch={setcolormatch}
            ColorChangeShare={ColorChangeShare}
            text={`${text}-sharedFile`}
            onSave_saveButton={handleFormSubmit}
          />
        </div>
      )}
    </div>
  );
};
export default SharedProjectsPopup;